import { withStyles } from '@material-ui/core';
import { Avatar, Box, InputBase } from '@mui/material';
import React, { FC, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import TagFacesOutlinedIcon from '@mui/icons-material/TagFacesOutlined';
import { CommentType } from 'APIs/BackstageCommentApi';
import BackstageComment, {
  IFormData,
} from 'interfaces/BackstageComment.interface';
import { handleSubmitComment } from 'APIs/utils';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { socket } from 'app/socket';
import { OtrData } from 'interfaces/OtrData.interface';

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '14px',
    },
  },
})(InputBase);

interface ICommentInput {
  parentCommentId?: string;
  postId: string;
  ownerId?: number;
  addComment?: (comment: BackstageComment, id: string) => void;
  type: CommentType;
  otr?: OtrData;
}

const OtrCommentInput: FC<ICommentInput> = ({
  parentCommentId,
  postId,
  addComment,
  type,
  otr,
  ownerId,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const authState = useAppSelector(selectAuth);
  const [formData, setFormData] = useState<IFormData>({
    postId: postId,
    parentCommentId: parentCommentId,
    content: '',
    type,
    createdAt: new Date().getTime(),
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleKeyDown = (key: string) => {
    if (key === 'Enter' && formData.content && !loading && authState.id) {
      console.log('commented')
      handleSubmitComment(
        formData,
        type,
        setLoading,
        setFormData,
        postId,
        dispatch,
        authState.id,
        ownerId,
        socket,
        otr,
        addComment,
        parentCommentId
      );
    }
  };

  const user0 = require('assets/Profile/buku_default_avatar.png');

  return (
    <Box
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        paddingRight: '12px',
        backgroundColor: 'rgba(150,143,206,0.12156862745098039 )',
        borderRadius: '10px',
        boxShadow: 'unset',
      }}
    >
      <Avatar>
        <img style={{ width: '40px' }} src={authState.avatar || user0} alt="" />
      </Avatar>
      <WhiteTextField
        sx={{ ml: 1, flex: 1, color: '#ffffff', fontSize: '14px' }}
        name={'content'}
        value={formData.content}
        onChange={e => handleChange(e)}
        onKeyDown={e => handleKeyDown(e.code)}
        placeholder="Add a comment..."
        inputProps={{ 'aria-label': 'Add a comment...' }}
        disabled={loading}
      />
      <IconButton
        style={{ color: '#c1c1c1', paddingRight: '0px', padding: '5px 0px' }}
      >
        <TagFacesOutlinedIcon />
      </IconButton>
    </Box>
  );
};

export default OtrCommentInput;
